import kitchenInstance from '../instance'

const setKitchenOrderStatus = (orderId, data) => {
  return kitchenInstance.put('/orders/' + orderId + '/status', data)
}

export default setKitchenOrderStatus
